import { TFunction } from '@lyearn/i18n';
import { UpdateQuestionEntity } from '@/types/schema';

const validateImageHotspot = (t: TFunction, question?: UpdateQuestionEntity) => {
  if (
    !question?.imageHotspotComponents?.set.length ||
    question?.imageHotspotComponents.set.length === 0
  ) {
    return {
      message: t('QuizCreator:Validations.AtleastOneHotspotRequired'),
      type: 'AtleastOneHotspotRequired',
    };
  }

  if (
    question.imageHotspotComponents.set.length === 1 &&
    question.globalDistractors?.set.length === 0
  ) {
    return {
      message: t('QuizCreator:Validations.AtleastOneDistractorRequired'),
      type: 'QuestionSettings',
    };
  }

  const isAnyIncorrectOptionEmpty =
    question?.globalDistractors?.set.findIndex((distractor) => !Boolean(distractor.text)) !== -1;
  if (isAnyIncorrectOptionEmpty) {
    return {
      message: t('QuizCreator:Validations.DistractorCantBeEmpty'),
      type: 'QuestionSettings',
    };
  }
};

export default validateImageHotspot;
